import { Component, OnInit } from '@angular/core';
import { AuthService } from '@authentication/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-auth-callback',
  template: `<div></div>`  
})
export class AuthCallbackComponent implements OnInit {

  constructor(private authService: AuthService, private router: Router) {}

  ngOnInit() {
    this.authService.completeAuthentication().finally(() => {
      this.router.navigate(['/home']);
    });
  }
}
